import React from "react";
import {Table, Button} from "reactstrap";
import {useSelector, useDispatch } from 'react-redux';
import {globals} from "../Globals/Globals"
import NestedTitlePicture3 from "../NestedTitlePicture3/NestedTitlePicture3";
import { openModalVideo } from "../../redux/modalSlice";
import {openModalStat, openModal} from "../../redux/modalSlice";
import {deleteVideo, revertStatusVideo} from "../../redux/videoSlice";
import MediaPlayer from "../MediaPlayer/MediaPlayer";

const VideosRawTableDataSync = (props) => {
    const dispatch = useDispatch();
    const {deleteVideo_result} = useSelector((state) => state.video)

    React.useEffect(() => {
        // eslint-disable-next-line no-unused-vars
        let isMounted = true

        if (deleteVideo_result.status == "deleted"){
            try{
                dispatch(openModal({title:"Vidéo supprimée"}));
            }
            finally{
                dispatch(revertStatusVideo())
            }
        }

        // Cleanup function
        return () => {
            isMounted = false;
        }
    }, [dispatch, deleteVideo_result]);

     /**
     * 
     * @param {*} this 
     * @param {*} handleManager 
     * @param {*} userItem 
     * @param {*} data_guid 
     */
    const handleManager = async (p_s_item_key, p_callback_handler) => {
        try {
            if (globals.parameters.debugging) console.log("handleManager::p_s_item_key =>", p_s_item_key)
                p_callback_handler(props.videos_list.find((item) => item.data_guid == p_s_item_key))
        } catch (error) {
            console.error(`handleManager for ${p_callback_handler} raise error ${error.message}`)
            alert(`handleManager for ${p_callback_handler} raise error ${error.message}`)
        }
    }

    /**
     * tableRendering
     */
    const tableRendering = () => {
        let table_body = null;

        if (!((props.videos_list != null) && (props.videos_list.length > 0))){
            table_body = <tr><td colSpan="4">Aucune vidéo</td></tr>;
        }
        else{
            table_body = props.videos_list.map((videoItem,i)=>{
                return  <tr key={videoItem.data_guid} className="thumbnail">
                            <td id="table-item-container">
                                <div id="table-item">
                                {/*<a href={videoItem.data_blob.data_tier.video_url} target="_blank">{videoItem.data_blob.data_tier.video_url}</a>*/}
                                <MediaPlayer 
                                    youtubeID_or_MP4url={videoItem.data_blob.data_tier.youtube_id}/>    
                                </div>
                                <div id="table-commands">
                                    {/* Deletion is not yet enabled because of only one video at a time */}
                                    {(props.videos_list.length > 1) &&
                                        <div className="cmd_btn_delete">

                                            <Button onClick={()=>{handleManager(videoItem.data_guid, (videoObject)=>{
                                                                                            dispatch(openModal(
                                                                                                {title:`Supprimer la vidéo ?`,
                                                                                                 okCallBack:(DialogObject)=>{dispatch(deleteVideo(videoObject))}})) })}}
                                            style={{cursor:"pointer"}}>Effacer</Button>
                                        </div>}
                                    
                                    {!props.read_only &&
                                        <div className="cmd_btn_update">
                                            <Button onClick={()=>{handleManager(videoItem.data_guid, (videoObject)=>{dispatch(openModalVideo({video_data_guid:videoObject, read_only:false}))})}} 
                                            style={{cursor:"pointer"}}>Modifier</Button>
                                        </div>}
                                </div>
                            </td>
                        </tr>});
                }

        return(
            <Table striped responsive={true}>
               <tbody>
                    {table_body}
                </tbody>
            </Table>
            );
    }

    return (
        <>
            {tableRendering()}
        </>);
}

export default VideosRawTableDataSync;
